<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header p-2">
              <h6 class="modal-title">Select SVG Icon</h6>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog()">
                <span aria-hidden="true">
                  <cancel-icon class="close-icon" style="height: 30px !important;
                    width: 30px !important;
                    color: #fff;">
                  </cancel-icon>
                </span>
              </button>
            </div>
            <div class="modal-body p-0">
                <div class="arrange-icons">
                    <div @click="selectIcon('image')" :class="{activeIcon:icon == 'image'}" >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M13.6 40.9c3.8 0 7-1.3 9.7-4 2.7-2.7 4-5.9 4-9.7 0-3.8-1.3-7-4-9.7-2.7-2.7-5.9-4-9.7-4-3.8 0-7 1.3-9.7 4-2.7 2.7-4 5.9-4 9.7 0 3.8 1.3 7 4 9.7 2.7 2.7 5.9 4 9.7 4zm20.5 20.5L22.7 50 0 72.7v13.6h100V54.5L70.5 25 34.1 61.4z" fill="#e89131"/></svg>
                    </div>
                    
                    <div @click="selectIcon('video')" :class="{activeIcon:icon == 'video'}">
                        <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M0 7.5h15.5v12.3H0V7.5zm20.5 0v85h59.2v-85H20.5zm14.4 18.9c.5 0 1 .1 1.4.4l15 10.6 15 10.6c1.2.8 1.5 2.6.8 3.9-.2.4-.5.7-.8.9l-15 10.6-15 10.6c-1.2.8-2.7.4-3.4-.9-.3-.5-.4-1-.4-1.5V29.2c0-1.5 1-2.7 2.4-2.8zM84.8 7.5H100v12.3H84.8V7.5zM0 25.4h15.5V38H0V25.4zm84.8 0H100V38H84.8V25.4zM0 43.7h15.5v12.6H0V43.7zm84.8 0H100v12.6H84.8V43.7zM0 61.9h15.5v12.6H0V61.9zm84.8 0H100v12.6H84.8V61.9zM0 80.1h15.5v12.3H0V80.1zm84.8 0H100v12.3H84.8V80.1z" fill="#6ae5b9"/></svg>
                    </div>
                    <div @click="selectIcon('audio')" :class="{activeIcon:icon == 'audio'}">
                        <svg   version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 104.23 122.88" style="fill:#418969" xml:space="preserve">
                            <g><path class="st0" d="M87.9,78.04c2.74-0.48,5.33-0.4,7.6,0.13V24.82L39.05,41.03v61.95c0.03,0.34,0.05,0.69,0.05,1.03 c0,0,0,0.01,0,0.01c0,8.34-8.75,16.62-19.55,18.49C8.76,124.37,0,119.12,0,110.77c0-8.34,8.76-16.62,19.55-18.48 c4.06-0.7,7.84-0.39,10.97,0.71l0-76.26h0.47L104.04,0v85.92c0.13,0.63,0.2,1.27,0.2,1.91c0,0,0,0,0,0.01 c0,6.97-7.32,13.89-16.33,15.44c-9.02,1.56-16.33-2.83-16.33-9.8C71.57,86.51,78.88,79.59,87.9,78.04L87.9,78.04L87.9,78.04z"/></g></svg>
                    </div>
                    <div @click="selectIcon('document')" :class="{activeIcon:icon == 'document'}">
                        <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M92.8 82.4H51.5c-1.6 0-2.9-1.3-2.9-2.9V20.6c0-1.6 1.3-2.9 2.9-2.9h41.3c1.6 0 2.9 1.3 2.9 2.9v58.9c0 1.6-1.3 2.9-2.9 2.9z" fill="#e8e8e8"/><path d="M81 35.3H51.5c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9H81c1.6 0 2.9 1.3 2.9 2.9 0 1.5-1.3 2.9-2.9 2.9zm0 11.8H51.5c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9H81c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9zm0 11.7H51.5c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9H81c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9zm0 11.8H51.5c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9H81c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9z" fill="#b2b2b2"/><path d="M59.3 97.2l-55-10.5V13.2l55-10.5v94.5z" fill="#0d47a1"/><path d="M43.7 68h-7l-4.6-23.1c-.3-1.3-.4-2.7-.4-4h-.1c-.1 1.6-.3 3-.5 4L26.3 68H19l-7.3-36h6.9l3.9 24c.2 1 .3 2.4.4 4.1h.1c0-1.3.3-2.7.6-4.2l5-23.9h6.7l4.6 24.2c.2.9.3 2.2.4 3.9h.1c.1-1.3.2-2.6.4-4l3.9-24H51L43.7 68z" fill="#fff"/></svg>
                    </div>
                    <div @click="selectIcon('pdf')" :class="{activeIcon:icon == 'pdf'}">
                        <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M95.2 63.2c-2.8-3-8.4-4.7-16.4-4.7-4.3 0-9.2.4-14.6 1.4-3-3-6.1-6.5-9-10.6-2.1-2.9-3.9-5.9-5.5-8.9 3.2-9.9 4.7-17.9 4.7-23.7 0-6.5-2.3-13.3-9.1-13.3-2.1 0-4.1 1.3-5.2 3.1-3 5.5-1.7 17.5 3.6 29.3-2 5.9-4 11.6-6.6 17.9-2.2 5.3-4.8 10.9-7.5 15.9-15.2 6.2-25 13.4-25.9 19-.4 2.1.3 4.1 1.8 5.6.5.4 2.5 2.1 5.8 2.1 10.1 0 20.7-16.6 26.1-26.7 4.1-1.4 8.3-2.7 12.4-3.9 4.5-1.3 9.1-2.3 13.2-3C73.6 72.4 83 74 87.7 74c5.8 0 7.9-2.4 8.6-4.4 1.1-2.5.3-5.3-1-6.8l-.1.4zm-5.4 4.1c-.4 2.1-2.5 3.5-5.4 3.5-.8 0-1.5-.1-2.3-.3-5.3-1.3-10.2-4-15.2-8.2 4.9-.8 9-1 11.6-1 2.9 0 5.4.1 7 .6 1.9.4 4.9 1.7 4.3 5.4zm-29.3-6.6c-3.6.7-7.4 1.6-11.4 2.7-3.2.9-6.5 1.8-9.8 3 1.8-3.5 3.3-6.9 4.7-10.1 1.7-4 3-8 4.4-11.8 1.4 2.4 2.9 4.8 4.4 6.9 2.5 3.3 5.1 6.5 7.7 9.3zM42.4 8.2c.6-1.1 1.7-1.7 2.6-1.7 2.9 0 3.4 3.4 3.4 6.1 0 4.5-1.4 11.4-3.7 19.3-4-11-4.3-20.1-2.3-23.7zM27.3 73.9c-7 11.8-13.8 19.2-17.9 19.2-.8 0-1.5-.3-2.1-.7-.8-.8-1.2-1.8-1-3 .8-4.2 8.7-10.1 21-15.5z" fill="#eb1d25" stroke="#eb1d25" stroke-width=".75" stroke-miterlimit="10"/></svg>
                    </div>
                    <div @click="selectIcon('zip')" :class="{activeIcon:icon == 'zip'}">
                        <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M91.6 28.7H76.9V14.1l14.7 14.6zM52.1 14.1v53.3h39.6V32.2H73.4V13.9H52.1v.2zM58.2 0H14.5v10.4h17.2l-10.9 8.3v8.9l15.9-12.2v-5h55.7V6.1L58.2 0zM36.9 22.4L21 34.6v8.9l15.9-12.2v-8.9zm-16.1 37l15.9-12.2v-8.9L20.8 50.6v8.8zm16.1 3.7v-8.9L21 66.5v4.8h-6.3v10.4h9.8v7h-5.9c-1.1-1.9-3-3-5.2-3-3.3 0-5.9 2.6-5.9 5.9 0 3.3 2.6 5.9 5.9 5.9 2.2 0 4.1-1.1 5.2-3h5.7v5.4h8.9v-5.4H39c1.1 1.9 3 3 5.2 3 3.3 0 5.9-2.6 5.9-5.9 0-3.3-2.6-5.9-5.9-5.9-2.2 0-4.1 1.1-5.2 3h-5.7v-7h25l34.3-6.1v-4.3H26.2l10.7-8.2z" fill="#fc3"/></svg>
                    </div>
                    <div @click="selectIcon('xls')" :class="{activeIcon:icon == 'xls'}">
                        <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="#fff">
                            <path d="M94.6 13.2h-42v73.5h42c1.5 0 2.6-1.2 2.6-2.6V15.9c0-1.5-1.1-2.7-2.6-2.7z" fill="#4caf50"/><path class="st1" d="M71 26.4h18.4v7.9H71zm0 26.2h18.4v7.9H71zm0 13.1h18.4v7.9H71zm0-26.2h18.4v7.9H71zM52.6 26.4h13.1v7.9H52.6zm0 26.2h13.1v7.9H52.6zm0 13.1h13.1v7.9H52.6zm0-26.2h13.1v7.9H52.6z"/><path fill="#2e7d32" d="M57.9 97.3L2.8 86.8V13.2L57.9 2.7z"/><path class="st1" d="M37.1 68l-6.2-11.7c-.2-.4-.5-1.2-.7-2.4H30c-.1.6-.4 1.4-.8 2.5L23 68h-9.7l11.5-18-10.5-18h9.9l5.2 10.8c.4.9.8 1.9 1.1 3h.1c.2-.7.6-1.7 1.1-3.1L37.3 32h9L35.6 49.8 46.7 68h-9.6z"/></svg>
                    </div>
                    <div @click="selectIcon('text')" :class="{activeIcon:icon == 'text'}">
                        <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M0 84.8h56.9V100H0V84.8m0-56.5h100v15.2H0V28.3zM0 0h100v15.2H0V0zm0 56.6h100v15.2H0V56.6z" fill="#bababa"/></svg>
                    </div>
                    <div @click="selectIcon('config')" :class="{activeIcon:icon == 'config'}" >
                        <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M19.1 64.5c-4.8 1.3-8.4 5.6-8.4 10.9 0 5.2 3.6 9.6 8.4 10.9V95h5.6v-8.8c4.8-1.3 8.4-5.6 8.4-10.9 0-5.2-3.6-9.6-8.4-10.9V5h-5.6v59.5zm8.4 10.8c0 3.1-2.5 5.6-5.6 5.6s-5.6-2.5-5.6-5.6 2.5-5.6 5.6-5.6 5.6 2.5 5.6 5.6zm11.3-50.6c0 5.2 3.6 9.6 8.4 10.9V95h5.6V35.5c4.8-1.3 8.4-5.6 8.4-10.9s-3.6-9.6-8.4-10.9V5h-5.6v8.8c-4.9 1.3-8.4 5.7-8.4 10.9zm16.8 0c0 3.1-2.5 5.6-5.6 5.6s-5.6-2.5-5.6-5.6 2.5-5.6 5.6-5.6 5.6 2.5 5.6 5.6zm11.3 33.7c0 5.2 3.6 9.6 8.4 10.9V95h5.6V69.3c4.8-1.3 8.4-5.6 8.4-10.9s-3.6-9.6-8.4-10.9V5h-5.6v42.6c-4.8 1.2-8.4 5.6-8.4 10.8zm16.9 0c0 3.1-2.5 5.6-5.6 5.6-3.1 0-5.6-2.5-5.6-5.6 0-3.1 2.5-5.6 5.6-5.6 3 0 5.6 2.5 5.6 5.6z" fill="#bababa" stroke="#bababa" stroke-width="2.5" stroke-miterlimit="10"/></svg>
                    </div>
                    <div  @click="selectIcon('svg')" :class="{activeIcon:icon == 'svg'}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M2.8 55V45c2.2-.2 3.9-.3 4.9-1 1-.3 1.9-1.3 2.7-2.4.8-1.2 1.3-2.5 1.7-4.4.2-1.3.5-3.5.5-6.7 0-5.4.2-9.1.8-11.3.5-2 1.5-3.9 2.7-5.1 1.3-1.2 3.4-2.2 5.9-3 1.7-.3 4.4-.8 8.3-.8h2.4v9.8c-3.2 0-5.4.2-6.2.7-.8.3-1.5.8-2.2 1.7-.5.7-.7 1.9-.7 3.5 0 1.7-.2 5.1-.5 9.8-.2 2.9-.5 5.1-1 6.6-.7 1.7-1.5 3-2.4 4.2-.8 1-2.4 2.2-4.2 3.4 1.7 1 3.2 2 4.2 3.2 1 1.2 1.9 2.9 2.5 4.5.7 1.9 1 4.2 1 7.2.2 4.5.2 7.4.2 8.8 0 1.9.2 3 .7 3.9.5.8 1.3 1.2 2.2 1.7.8.3 3 .7 6.2.7v9.8H30c-3.9 0-7.1-.2-8.9-.8-2.2-.7-3.9-1.7-5.4-3-1.5-1.3-2.4-3-3-5.1-.5-2-.7-5.2-.7-9.6 0-5.1-.2-8.4-.7-9.8-.7-2.2-1.7-3.9-3-4.9-.8-1-2.9-1.6-5.5-1.6zm94.1 0c-2.2.2-3.9.3-4.9 1-1 .3-1.9 1.3-2.7 2.4-.8 1.2-1.3 2.5-1.7 4.4-.2 1.3-.5 3.5-.5 6.7 0 5.4-.2 9.1-.8 11.3-.5 2.2-1.5 3.9-2.7 5.1-1.3 1.2-3.4 2.2-5.9 3-1.7.3-4.4.8-8.3.8H67v-9.8c3.2 0 5.1-.2 6.2-.7 1-.3 1.7-1 2.2-1.7.5-.7.7-1.9.7-3.5s.2-4.9.5-9.6c.2-2.9.7-5.2 1.3-6.7.7-1.9 1.5-3.2 2.5-4.4 1-1.2 2.4-2.2 4-3.2-2.7-1.7-4.4-2.9-5.2-4-1.3-1.9-2.4-4.2-2.7-6.7-.5-2-.7-6.2-.7-12.6 0-2-.2-3.4-.7-4.2-.5-.7-1-1.2-1.9-1.7-.8-.3-3-.7-6.4-.7v-9.8h2.4c3.9 0 7.1.2 8.9.8 2.2.7 3.9 1.7 5.4 3 1.5 1.3 2.4 3 3 5.1.5 2 .8 5.2.8 9.6 0 5.1.2 8.3.7 9.8.7 2.2 1.7 3.9 3 4.5 1.3 1 3.4 1.3 5.9 1.7V55zm-28.3-1c-1.7-.5-2.7-2-2.7-3.7 0-1.7 1.2-3.2 2.7-3.7.5-.2.8-.7.7-1.2-.5-1.9-1.2-3.5-2.2-5.1-.2-.5-.8-.7-1.3-.3-.5.3-1.2.5-1.9.5-2.2 0-3.9-1.9-3.9-3.9 0-.7.2-1.3.5-1.9.2-.5 0-1-.3-1.3-1.5-1-3.4-1.7-5.1-2.2-.5-.2-1 .2-1.2.7-.5 1.7-2 2.7-3.7 2.7-1.7 0-3.2-1.2-3.7-2.7-.2-.5-.7-.8-1.2-.7-1.9.5-3.5 1.2-5.1 2.2-.5.2-.7.8-.3 1.3.3.5.5 1.2.5 1.9 0 2.2-1.9 3.9-3.9 3.9-.7 0-1.3-.2-1.9-.5-.5-.2-1 0-1.3.3-1 1.5-1.7 3.4-2.2 5.1-.2.5.2 1 .7 1.2 1.7.5 2.7 2 2.7 3.7 0 1.7-1.2 3.2-2.7 3.7-.5.2-.8.7-.7 1.2.5 1.9 1.2 3.5 2.2 5.1.2.5.8.7 1.3.3.5-.3 1.2-.5 1.9-.5 2.2 0 3.9 1.9 3.9 3.9 0 .7-.2 1.3-.5 1.9-.2.5 0 1 .3 1.3 1.5 1 3.4 1.7 5.1 2.2h.2c.3 0 .8-.2 1-.7.5-1.7 2-2.7 3.7-2.7 1.7 0 3.2 1.2 3.7 2.7.2.5.7.8 1.2.7 1.9-.5 3.5-1.2 5.1-2.2.5-.2.7-.8.3-1.3-.3-.5-.5-1.2-.5-1.9 0-2.2 1.9-3.9 3.9-3.9.7 0 1.3.2 1.9.5.5.2 1 0 1.3-.3 1-1.5 1.7-3.4 2.2-5.1.2-.6-.2-1.1-.7-1.2zm-18.7 2.1c-3.4 0-6.1-2.7-6.1-6.1 0-3.4 2.7-6.1 6.1-6.1S56 46.6 56 50c0 3.5-2.7 6.1-6.1 6.1z" fill="#bababa" stroke="#bababa" stroke-width=".5" stroke-miterlimit="10"/></svg>
                    </div>
                    <div @click="selectIcon('csv')" :class="{activeIcon:icon == 'csv'}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M71.8 15.5h25.5v17H71.8v-17zm0 26.2h25.5v17H71.8v-17zm0 25.8h25.5v17H71.8v-17zm-34.7 0h25.5v17H37.1v-17zm-34.3 0h25.5v17H2.8v-17zm34.6-25.6h25.5v17H37.4v-17zm-34.6 0h25.5v17H2.8v-17zm34.6-26.4h25.5v17H37.4v-17zm-34.6 0h25.5v17H2.8v-17z" fill="#55b767"/></svg>
                    </div>
                    <div @click="selectIcon('xml')" :class="{activeIcon:icon == 'xml'}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M1 44.3L28.9 15v14.9l-19 19.3v.2l18.9 19.3v14.9L1 54.2v-9.9zM53.6 7.5H61l-14.4 85h-7.2c-.1 0 14.2-85 14.2-85zm17.5 61.3L90 49.5v-.2L71.1 30.1V15.2L99 44.6v10.3L71.1 84.1V68.8z" fill="#bababa" stroke="#bababa" stroke-width="2" stroke-miterlimit="10"/></svg>
                    </div>
                    <div  @click="selectIcon('sh')" :class="{activeIcon:icon == 'sh'}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M35.7 39.3h28.4v7H35.7v-7zm0 14.2h28.4v7H35.7v-7zm0 14.2h28.4v7H35.7v-7zM85.3 4H28.7C21 4 14.6 10.2 14.6 18.1v63.7H.4C.4 89.6 6.6 96 14.6 96h56.7c7.7 0 14.2-6.3 14.2-14.2V25.1h14.2v-7C99.4 10.2 93.2 4 85.3 4zm-7 76.6c0 4.6-3.7 8.3-8.3 8.3H18.1c3.5-2.4 3.5-7 3.5-7V18.1c0-3.9 3.1-7 7-7s7 3.1 7 7v7h42.5v55.4h.2zM42.9 18.1v-7h42.5c6.4 0 7 4.1 7 7H42.9z" fill="#bababa" stroke="#bababa" stroke-width=".75" stroke-miterlimit="10"/></svg>
                    </div>
                    <div @click="selectIcon('exe')" :class="{activeIcon:icon == 'exe'}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M98.2 59.8c-4.3-1.4-6.9-5.3-6.9-9.8s2.9-8.3 6.9-9.8c1.2-.4 2-1.8 1.6-3.1-1.2-4.7-3.1-9-5.5-13.2-.6-1.2-2.2-1.6-3.5-1-1.4.8-3.3 1.2-4.9 1.2-5.7 0-10.2-4.7-10.2-10.2 0-1.6.4-3.5 1.2-4.9.6-1.2.2-2.6-1-3.5C72 3.2 67.5 1.4 62.8.2c-1.2-.4-2.6.4-3.1 1.6-1.4 4.3-5.3 6.9-9.8 6.9s-8.3-2.9-9.8-6.9C39.7.6 38.3-.2 37 .2c-4.7 1.2-9 3.1-13.2 5.5-1.2.6-1.6 2.2-1 3.5.8 1.4 1.2 3.3 1.2 4.9 0 5.7-4.7 10.2-10.2 10.2-1.6 0-3.5-.4-4.9-1.2-1.2-.6-2.6-.2-3.5 1C3 28.2 1.1 32.7-.1 37.3c-.4 1.2.4 2.6 1.6 3.1 4.3 1.4 6.9 5.3 6.9 9.8S5.5 58.5 1.5 60c-1.2.4-2 1.8-1.6 3.1 1.2 4.7 3.1 9 5.5 13.2.6 1.2 2.2 1.6 3.5 1 1.4-.8 3.3-1.2 4.9-1.2 5.7 0 10.2 4.7 10.2 10.2 0 1.6-.4 3.5-1.2 4.9-.6 1.2-.2 2.6 1 3.5 4.1 2.4 8.6 4.3 13.2 5.5h.6c1 0 2-.6 2.4-1.8 1.4-4.3 5.3-6.9 9.8-6.9s8.3 2.9 9.8 6.9c.4 1.2 1.8 2 3.1 1.6 4.7-1.2 9-3.1 13.2-5.5 1.2-.6 1.6-2.2 1-3.5-.8-1.4-1.2-3.3-1.2-4.9 0-5.7 4.7-10.2 10.2-10.2 1.6 0 3.5.4 4.9 1.2 1.2.6 2.6.2 3.5-1 2.4-4.1 4.3-8.6 5.5-13.2.5-1.2-.1-2.7-1.6-3.1zm-48 5.7c-8.6 0-15.5-6.9-15.5-15.5s6.9-15.5 15.5-15.5S65.7 41.4 65.7 50s-7 15.5-15.5 15.5z" fill="#abb3d6"/></svg>
                    </div>
                    <div @click="selectIcon('odt')" :class="{activeIcon:icon == 'odt'}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                            <path d="M64.6 38.3h31.7v5.1H64.6v-5.1zM2.8 52h93.7v5.5H2.8V52zm0 13.7h93.7v5.5H2.8v-5.5zm52.5-50.4h3.4C64 15.7 68 17 72 18.6c7.7-3.4 18.4-.8 25.3 1.8-8.6-.8-18.9 0-24.8 3.4-6.2-4.7-17.5-6.2-28.1-4.7 3.1-2.1 6.7-3.3 10.9-3.8zm-2.4 13.1c-6.2.3-11.3 2.4-14.7 5.2C27.9 29 10.3 31 3.8 37.2c-.7.3-1.1.8-1 1.5 5.9-1.8 12.9-3.3 20.1-2.6s12.6 2.9 16.6 6.2c7.3-6.7 18.4-10.4 32.3-10.3-4.9-2.1-11.9-3.9-18.9-3.6zM2.8 79.1h93.7v5.5H2.8v-5.5z" fill="#34a6f4" stroke="#34a6f4" stroke-width=".5" stroke-miterlimit="10"/></svg>
                    </div>
                </div>
            </div>
            <div class="modal-footer p-0 primary-btn-style">
                <button class="btn btn-outline-secondary ml-1" title="Close" @click="closeDialog()">Cancel</button>
                <button class="btn btn-outline-primary ml-1 mr-2" title="Reject with comment" @click="updateSVG()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
    
    <script>
    import cancelIcon from "../core/InlineCancelField.vue";
    // import Utils from '../../components.utils.js';
    // import Constants from "../../components.constants.js";
    
    export default {
      props:['fileInfo'],
      data(){
        return{
          selectedFileInfo:{},
          icon:null
        }
      },
      components:{
        'cancel-icon':cancelIcon,
      },
      methods:{
        selectIcon(value) {
            this.icon = value;
        },
        closeDialog(){
          this.$emit("close")
        },
        updateSVG(){
            this.$emit('uploadSvgIconAsCover', this.icon);
            this.close();
        }
      },
      created(){
      },
    }
    </script>
    
    <style scoped lang="scss">
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;

    svg{
        margin:10px !important;
        color: #aaa;
    }
    
    svg:hover{
        padding:2px;
    }
    
    .activeIcon{
        border: 1px solid #3a3a3a;
        border-radius: 13px;
        background: #303030;
        height:55px;
    }

    .arrange-icons{
        flex-wrap: wrap;
        display:flex;
        justify-content: flex-start;
        padding:10px;
        svg{
            height:30px;
            width:30px;
            margin-bottom: 17px !important;
        }
    }
    .modal-dialog {
        max-width: 600px;
        width: 420px;
        height: 300px;
        margin: 0;
        padding: 0;
      }
      
      .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
         background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
          background: $primary-background;
          height: 200px;
          display: inline-flex;
          flex-direction: column;
        }
      }
    
    .modal {
        text-align: center;
        padding: 0 !important;
        display: block;
        position: fixed;
        inset-inline-start: 0px;
        top: 10%;
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal:before {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      margin-inline-end: -4px;
    }
    .modal-dialog {
      display: inline-block;
      text-align: start;
      vertical-align: middle;
    }
    
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    
    .border{
        border: $border-color !important;
    }
    
    .activeclass{
        color: $active-blue;
    }
    
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        display: flex;
        align-items: center;
        height:70px;
        .modal-title{
          color:$text-color;
        }
    }
    .modal-footer{
      padding: 5px 0px;
    }
    
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }
    
    ul{
        list-style-type: none;
    }
    
    .primary-btn-style{
        text-align: end;
        button{
            height: 38px;
            font-size:14px;
            width: inherit;
        }
        .text-light:hover{
          text-decoration: underline;
        }
    }
    .secondary-btn-style{
      color:$text-color;
    }
    .close-icon:hover{
      background: $icon-hover;
      border-radius: 20px;
    }
    .nav-item{
        color: $dull-text-color !important;
    }
    .inactive:hover{
      color:$text-color !important;
    }
    .active{
        background: $primary-background !important;
        color:$active-blue  !important;
        border-bottom: 2px solid $active-blue ;
    }
    .top-nav-bar{
        text-align: center;
        background: $primary-background;
    }
    
    /* width */
      ::-webkit-scrollbar {
        width: 8px;
        height:8px;
      }
    
      /* Track */
      ::-webkit-scrollbar-track {
        background: $scrollbar-track-background !important;
      }
    
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background !important;
      }
    
      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: $bg-color-on-hover !important;
      }
    
    .common-input-field{
        margin-inline-start: 3%;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        label{
            width: 30%;
            color: $secondary-text-color;
            word-break: break-word;
        }
        input{
            flex:1;
        }
    }
    .input-text-field{
        height: 44px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
    }
    
      .add-border{
        border: $border-color;
      }
    
      .minMaxTextarea{
        min-height: 38px;
      }
    
      textarea:focus{
        outline: none;
        bottom: 0px;
        inset-inline-start: 0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
      }
    
      .dull-the-text{
        color: $dull-text-color;
      }
    
      ::placeholder {
        color: $dull-text-color !important;
      }
    
    ul,.placeholder-file-name{
        list-style-type: none;
        padding: 0px;
        border: 1px solid #384445;
        border-radius: 10px;
        background: #202729 !important;
        margin: 10px 5px;
        padding: 5px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        margin-top: 0px;
        li{
            display:inline-flex;
            width: 97%;
            padding:2px;
            .key-style{
                color:$dull-text-color;
                width:17%;
                text-align: end;
            }
            .value-style{
                color: #b6b6b6;
                width: 80%;
                text-align: start;
                margin-inline-start: 11px;
                word-break: break-all;
            }
        }
    }
    
    .version-basic-info-wrapper{
        display: flex;
        flex-direction: column;
        padding:5px;
        position: relative;
        margin-bottom: 10px;
        .version-number-tag{
            border: $border-color;
            padding: 5px;
            width: 50px;
            height: 30px;
            font-size: 12px;
            border-radius: 10px;
            display: inline-flex;
            justify-content: center;
            background: #3a6e8b;
            margin: 0px 5px;
        }
        .latest-version-tag{
            border: $border-color;
            padding: 5px;
            width: 100px;
            height: 30px;
            font-size: 12px;
            border-radius: 10px;
            display: inline-flex;
            justify-content: center;
            background: #4d8b3a;
            margin: 0px 5px;
        }
    }
    
    .version-basic-info-wrapper:hover{
      border: $border-color;
      border-radius: 10px;
      background: #22272b;
      padding: 4px;
      .actions-on-manage-versions{
        visibility: visible;
        svg{
          margin-inline-end:5px;
        }
      }
    }
    
    .actions-on-manage-versions{
      visibility: hidden;
    }
    
    .actions-on-manage-versions{
      cursor: pointer;
      position: absolute;
      inset-inline-end: 0px;
      border: $border-color;
      width: auto;
      height: 35px;
      border-radius: 4px;
      top: 4px;
      inset-inline-end: 3px;
      padding: 0px 5px;
      background: $bg-color-on-hover;
      svg{
          margin:2px;
          background: #d1d2d31a;
          padding: 4px;
          height: 28px;
          width: 28px;
          border-radius: 4px;
          margin-inline-end: 5px;
          color: #c0c0c0;
      }
      svg:hover{
          background: #fdfeff54;
      }
    }
    
    .version-info-display{
      overflow: auto;
      padding-inline-start: 10px;
    }
    
    .tag-style{
        font-size:12px!important;
        height: 30px!important;
        display: inline-flex!important;
        margin: 2px!important;
        border: 1px solid $tags-border-color!important;
        border-radius: 10px!important;
        min-width: 50px!important;
        padding: 0!important;
        text-align: center;
        width: auto!important;
        padding-inline-start: 1px!important;
        justify-content: center;
        padding-top: 4px!important;
        background: $tags-background-color;
        span {
            padding: 0px 8px !important;
            margin-inline-start: 0px !important;
            font-size:12px !important;
            border-radius: 15px !important;
            position: relative !important;
            top: 1px !important;
        }
    }
    .version-placeholder-tag{
      border: $border-color;
      padding: 4px;
      width: 125px;
      height: 30px;
      font-size: 15px;
      border-radius: 10px;
      display: inline-flex;
      justify-content: center;
      background: #d8b913fc;
      margin: 0px 5px;
      color: #000;
    }
    .media-preview-modal{
      top: 0px !important;
    }
    
    </style>
    